import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const getTasks = async (idsStr) => {
  const response = await apollo.query({
    query: gql(`
    query getTasks($taskIds:String) {
      tasks(taskIds: $taskIds) {
        id description tasklistId status
      }
    }
    `),
    variables: { taskIds: idsStr }
  })
  return response.data.tasks
}

export const executeTask = async (task) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation ExecuteTask($taskId: String!, $tasklistId: String!, $description: String!) {
          executeTask(taskId: $taskId, tasklistId: $tasklistId, description: $description) { message error }
        }`),
      variables: { taskId: task.id, tasklistId: task.tasklistId, description: task.description }
    })
  return response
}

export const executeBucketRunTask = async (bucketId, taskId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation executeBucketRunTask($bucketId: Int!, $taskId: Int!) {
          executeBucketRunTask(taskId: $taskId, bucketId: $bucketId) { message error }
        }`),
      variables: { bucketId, taskId }
    })
  return response.data.executeBucketRunTask
}

export const executeSelectedCaseRunTask = async (caseIds, taskId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation executeSelectedCaseRunTask($caseIds: [Int]!, $taskId: Int!) {
        executeSelectedCaseRunTask(taskId: $taskId, caseIds: $caseIds) { message error }
      }`),
      variables: { caseIds, taskId }
    })
  return response.data.executeSelectedCaseRunTask
}

export const createTaskTemplate = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
          mutation createTaskTemplate($tasklistTemplateId: Int!, $description: String!, $position: Int!, $actionType: String!, $actionDefinition: String!, $guidance: String!) {
            createTaskTemplate(tasklistTemplateId: $tasklistTemplateId, description: $description, position: $position, actionType: $actionType, actionDefinition: $actionDefinition, guidance: $guidance) { id createdAt message error }
          }
        `),
      variables: { tasklistTemplateId: data.tasklist_id, description: data.description, position: data.position, actionType: data.actionType, actionDefinition: data.actionDefinition, guidance: data.guidance }
    })
  return response.data.createTaskTemplate
}

export const updateTaskTemplate = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
          mutation updateTaskTemplate($id: Int!, $description: String!, $position: Int!, $actionType: String!, $actionDefinition: String!, $guidance: String!, $fieldset: String) {
            updateTaskTemplate(id: $id, description: $description, position: $position, actionType: $actionType, actionDefinition: $actionDefinition, guidance: $guidance, fieldset: $fieldset) { message error }
          }
        `),
      variables: { id: data.id, description: data.description, position: data.position, actionType: data.actionType, actionDefinition: data.actionDefinition, guidance: data.guidance, fieldset: data.fieldset }
    })
  return response.data.updateTaskTemplate
}

export const deleteTaskTemplate = async (taskId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
          mutation deleteTaskTemplate($id: Int!) {
            deleteTaskTemplate(id: $id) { message error }
          }
        `),
      variables: { id: taskId }
    })
  return response.data.deleteTaskTemplate
}
